var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6669 21.1111V18.8889C16.6669 17.7102 16.1986 16.5797 15.3651 15.7462C14.5316 14.9127 13.4012 14.4445 12.2224 14.4445H5.55577C4.37703 14.4445 3.24657 14.9127 2.41308 15.7462C1.57958 16.5797 1.11133 17.7102 1.11133 18.8889V21.1111",
    stroke: "#01589B",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88976 9.99997C11.3444 9.99997 13.3342 8.01013 13.3342 5.55553C13.3342 3.10093 11.3444 1.11108 8.88976 1.11108C6.43516 1.11108 4.44531 3.10093 4.44531 5.55553C4.44531 8.01013 6.43516 9.99997 8.88976 9.99997Z",
    stroke: "#01589B",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 21.1111V18.8889C23.3326 17.9041 23.0048 16.9475 22.4015 16.1692C21.7982 15.3909 20.9535 14.8351 20 14.5889",
    stroke: "#01589B",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 1.25549C17.622 1.50027 18.4694 2.05627 19.0745 2.83584C19.6796 3.6154 20.0081 4.57419 20.0081 5.56105C20.0081 6.5479 19.6796 7.50669 19.0745 8.28626C18.4694 9.06582 17.622 9.62182 16.666 9.8666",
    stroke: "#01589B",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.feca43ec7479fb6edfd6e77e3ab27c80.svg";
export { ForwardRef as ReactComponent };